import styles from './styles.module.scss';

export const DisclaimerFooter = () => (
  <div className={styles['footer']}>
    <p className={styles['description']}>
      onBeacon can make mistakes
    </p>
  </div>
);

export default DisclaimerFooter;
